import { jsx as i } from "react/jsx-runtime";
import s from "@mui/material/AccordionDetails";
import e from "styled-components";
const a = {
  root: "detailsRoot"
}, d = e(s).withConfig({
  displayName: "StyledAccordionDetails"
})([
  "&.detailsRoot{padding:16px;font-size:",
  ";}"
], ({ theme: o }) => o.typography.body200.fontSize), l = ({ children: o, ...t }) => /* @__PURE__ */ i(d, {
  ...t,
  classes: a,
  children: o
});
l.displayName = "AccordionDetails";
export {
  l as default
};
